"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      addDialog: false,
      listData2: [],
      defaultColumn2: [{
        name: "组别名称",
        prop: "groupName",
        isShow: true,
        width: "100"
      }],
      options2: [{}],
      page2: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData2: 0,
      modelData2: {
        queryValue: ""
      },
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "组别名称",
        prop: "groupName",
        isShow: true,
        width: "150"
      }, {
        name: "阶段名称",
        prop: "stageName",
        isShow: true,
        width: "150"
      }, {
        name: "所属项目",
        prop: "matchName",
        isShow: true,
        width: "150"
      }],
      funBtns: [{
        size: "small",
        click: "delStageGroup",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }, {
        size: "small",
        click: "save",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "参赛作品设置",
        class: "editor",
        option: "worksSet",
        span: 2
      },
      // {
      //   name: "权限设置",
      //   class: "editor",
      //   option: "roleSet",
      //   span: 4
      // },
      {
        name: "评分项设置",
        class: "editor",
        option: "scoreSet",
        span: 4
      }, {
        name: "移除",
        class: "delet",
        option: "delStageGroup",
        span: 2
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      checkBoxs2: []
    };
  },
  methods: {
    // 获取阶段下组别
    getStageGroupList: function getStageGroupList() {
      var _this = this;
      (0, _project.stageGroupList)({
        stageId: this.$route.query.id,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        if (data.list.length > 0) {
          _this.listData = data.list;
          _this.totalData = data.total;
        }
      });
    },
    // 提交组别
    subGroup: function subGroup() {
      var _this2 = this;
      var l = this.checkBoxs2.length;
      if (l) {
        (0, _project.stageGroupAdd)({
          groupIds: this.checkBoxs2,
          stageId: this.$route.query.id
        }).then(function (res) {
          _this2.$message.success("操作成功。");
          _this2.addDialog = false;
          _this2.getStageGroupList();
        });
      } else {
        this.$message.error("请先勾选数据。");
      }
    },
    // 参赛作品设置
    worksSet: function worksSet(e) {
      this.$router.push({
        path: "/object/entrySet",
        query: {
          groupId: e.groupId,
          matchId: e.matchId,
          stageId: e.stageId
        }
      });
    },
    listBureau: function listBureau() {},
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    // 新增 获取未分配的组别列表
    save: function save() {
      var _this3 = this;
      (0, _project.noStageGroup)({
        matchId: this.$route.query.matchId,
        stageId: this.$route.query.id,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this3.listData2 = data.list;
        _this3.totalData2 = data.total;
        _this3.addDialog = true;
      });
    },
    // 评分项设置
    scoreSet: function scoreSet(e) {
      console.log(e);
      this.$router.push({
        path: "/object/gradeItemSet",
        query: {
          stageId: e.stageId,
          matchId: e.matchId,
          groupId: e.groupId
        }
      });
    },
    // 删除该阶段下的组别
    delStageGroup: function delStageGroup(row) {
      var _this4 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.stageGroupDel)({
          idList: id
        }).then(function () {
          _this4.getStageGroupList();
          _this4.$message.success("操作成功。");
        });
      }).catch(function () {
        _this4.$message.info("取消删除。");
      });
    },
    editBureau: function editBureau() {},
    handleSelectionChange: function handleSelectionChange(e) {
      var _this5 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this5.checkBoxs.push(item.id);
      });
    },
    handleSelectionChange2: function handleSelectionChange2(e) {
      var _this6 = this;
      this.checkBoxs2 = [];
      e.forEach(function (item) {
        _this6.checkBoxs2.push(item.id);
      });
    },
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getStageGroupList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getStageGroupList();
    },
    handleCurrentChange2: function handleCurrentChange2(e) {
      this.page2.pageNumber = e;
      this.save();
    },
    handleSizeChange2: function handleSizeChange2(e) {
      this.page2.pageSize = e;
      this.page2.pageNumber = 1;
      this.save();
    },
    handleClose: function handleClose(done) {
      done();
    }
  },
  created: function created() {
    this.getStageGroupList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};